import _ from 'lodash';
import { constantsActive } from 'utils/constants/constants'

export default class ObjectTeams {
	
	static defaults = {
		active: constantsActive.YES,
	}
	
	static getAvailableFor( object ) {
		return _.filter(
			_.map( _.get( object, 'available_for_teams', [] ), available_for => {
				return _.get(available_for, ['team', 'guid'], null);
			})
		);
	}
	
	static getOptions( teams, availableForTeams = [] ) {
		const teamOptions = [];
		_.forEach( teams, team => {
			if( team.active === constantsActive.YES || _.includes( availableForTeams, team.guid ) ) {
				teamOptions.push( {
					key: team.guid,
					value: team.name
				} )
			}
		})
		
		return teamOptions;
	}
}
